// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2fHe7","col":"styles_col__2WiDb","actions":"styles_actions__nZS5m","conflict":"styles_conflict__3xutk"};